<template>
  <v-row justify="center" class="modal-row-container">
    <v-card flat class="modal-card">
      <v-card-title>
        <span class="headline">{{ modalTitle }} Call Flow</span>
        <v-spacer></v-spacer>
        <v-btn text icon color="grey" @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <confirm-delete-in-modal
            v-if="showConfirmDelete"
            @confirmed="onConfirmDelete"
          ></confirm-delete-in-modal>
          <v-form ref="form" v-model="valid">
            <call-flow-setup
              ref="callFlowSetup"
              :FlowId="callFlowId"
              Source="call-flow-modal"
              class="dialog-background"
            ></call-flow-setup>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions class="modal-actions">
        <v-spacer></v-spacer>
        <v-btn v-if="showDelete" color="blue darken-1" text @click="onDelete"
          >Delete</v-btn
        >
        <v-btn color="primary tile" @click="onSave"
          >&nbsp;&nbsp;&nbsp;Save&nbsp;&nbsp;&nbsp;</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
import { VALIDATION_RULES } from "../../../helpers/ValidationRules";
import { MASKS } from "../../../helpers/Masks";
import { mask } from "vue-the-mask";
import CallFlowSetup from "./CallFlowSetup";

const ConfirmDeleteInModal = () =>
  import(
    /* webpackChunkName: "components-customers-modals-ConfirmDeleteInModal" */ `../../customers/modals/ConfirmDeleteInModal.vue`
  );

export default {
  name: "CallFlowModal",
  props: {
    callFlowId: Number
  },
  directives: {
    mask
  },
  components: {
    ConfirmDeleteInModal,
    CallFlowSetup
  },
  data: () => ({
    dialog: true,
    valid: true,
    showConfirmDelete: false,
    masks: MASKS,
    rules: VALIDATION_RULES
  }),
  computed: {
    modalTitle() {
      return this.isAddNew ? "Add" : "Edit";
    },
    isAddNew() {
      return this.callFlowId == -1;
    },
    showDelete() {
      return this.callFlowId > 0 && !this.showConfirmDelete;
    },
    callFlowType() {
      const listType = this.$store.getters["entities/listTypes/query"]()
        .withAllRecursive(1)
        .where("code", value => ["call_flow"].includes(value))
        .first();
      return listType;
    },
    callFlowTypeId() {
      const listType = this.callFlowType;
      if (listType && listType.id) {
        return listType.id;
      }
      return null;
    }
  },
  created() {},
  methods: {
    onClose() {
      if (this.$route.name == "calls") {
        this.$root.$children[0].$refs["router-view"].$refs[
          "call-center-rail"
        ].$refs["telecom-pane"].showDialogContainer = false;
      } else {
        this.$root.$children[0].$refs["router-view"].$refs[
          "settings-center-rail"
        ].$refs["telecom-pane"].showDialogContainer = false;
      }
    },
    onSave() {
      if (this.$refs.form.validate()) {
        const newFlow = this.$refs["callFlowSetup"].flowList;
        for (let i = 0; i < newFlow.length; i++) {
          const flowItem = newFlow[i];
          if (i + 1 < newFlow.length) {
            flowItem.redirectTo = newFlow[i + 1].uid;
          }
        }
        const editedItem = {
          isDirty: true,
          listTypeId: this.callFlowTypeId,
          name: this.$refs["callFlowSetup"].flowName,
          rank: this.callFlowType.items.length,
          meta: {
            uid: this.$refs["callFlowSetup"].flowUID || this.$uuidv4(),
            flow: this.$refs["callFlowSetup"].flowList
          }
        };
        if (this.callFlowId > 0) {
          editedItem.id = this.callFlowId;
          this.$store.dispatch("entities/listItems/updateListItem", editedItem);
        } else {
          this.$store.dispatch("entities/listItems/createListItem", editedItem);
        }
        this.onClose();
      }
    },
    onDelete() {
      this.showConfirmDelete = true;
    },
    onConfirmDelete() {
      this.$store.dispatch("entities/listItems/deleteListItem", {
        id: this.callFlowId,
        isDirty: true
      });
      this.onClose();
    }
  }
};
</script>
<style scoped lang="stylus">
.modal-row-container {
  padding: 1rem;
  margin: 0;
}
.modal-card {
  width: 100%;
  margin: 0;
}
.headline {
  padding-left: .5rem;
}
.modal-actions {
  padding: 1rem;
}
</style>
